export default [
  {
    nome: 'Cadastros em andamento',
    icon: 'fal fa-edit',
    routeGroup: 'listagem/praticas',
    permissao: 'VIEW_CAIXA_ENTRADA'
  },
  {
    nome: 'Consultar processos',
    icon: 'el-icon-search',
    routeGroup: 'listagem/finalizados',
    permissao: 'VIEW_CAIXA_FINALIZADOS'
  }
]



// WEBPACK FOOTER //
// ./src/libs/constants/painel/cadastro/menu.js